import { Box } from '@mui/system';
import PropTypes from 'prop-types';
import { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Icon } from '@iconify/react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  DialogContentText,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Tab,
  Tabs,
  TextField,
  Tooltip,
  Typography,
  Chip,
  TableRow,
  InputAdornment
} from '@mui/material';
// icons
import CloseIcon from '@mui/icons-material/Close';
import searchFill from '@iconify/icons-eva/search-fill';

import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useDispatch } from 'react-redux';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { AiFillPrinter, AiOutlineFileText } from 'react-icons/ai';
import { CgPlayListAdd } from 'react-icons/cg';
import { GoFilePdf } from 'react-icons/go';
import { SiMicrosoftexcel } from 'react-icons/si';
import { TbFileSymlink } from 'react-icons/tb';
// react icons
import { BiCloudDownload, BiShareAlt } from 'react-icons/bi';
import { BsAspectRatio } from 'react-icons/bs';
import { MdCheckBox, MdCreditScore, MdEmail, MdTextsms, MdUpdate } from 'react-icons/md';
import { RiFileInfoLine, RiPrinterCloudFill, RiWhatsappFill } from 'react-icons/ri';
import { Document, pdfjs, Page as Pages } from 'react-pdf';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import profileImg from './profileImg.png';
import Scrollbar from '../../components/Scrollbar';
import Loader from './Loader';
import { StyledTableCell, StyledTableRow, SearchStyle } from './Styling';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';
import useGlobalSelector from '../../store/Slice/Global/GlobalSelector';
import CustomDialog from '../../components/CustomDialogue';
import CustomInput from '../../components/CustomInput';
import CustomSelect from '../../components/CustomSelect';
import { getBankDropdownData, getMasterListType } from '../../store/Slice/Global/GlobalSlice';
import { transformToSelectOptions } from '../../utils/CommonFunction';
import {
  getLoginApproveProcess,
  getLoginUserProfile,
  getRecoRecommendedBank
} from '../../store/Slice/LoginModule/LoginModuleSlice';
import useLoginModuleSelector from '../../store/Slice/LoginModule/LoginModuleSelector';
import { getBranchRecordByBank } from '../../store/Slice/Lead/LeadSlice';
import useLeadSelector from '../../store/Slice/Lead/LeadSelector';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export const validationSchema = yup.object().shape({
  submittedToBankId: yup
    .string()
    .nullable()
    .required('Bank Name is required')
    .notOneOf(['', ' ', null], 'Please select a valid Bank'),

  submissionModeTypeId: yup
    .string()
    .nullable()
    .required('Mode of Submission is required')
    .notOneOf(['', ' ', null], 'Please select a valid Mode of Submission'),

  loginTypeId: yup
    .string()
    .nullable()
    .required('Login Type is required')
    .notOneOf(['', ' ', null], 'Please select a valid Login Type'),

  dsaLoginCode: yup
    .string()
    .nullable()
    .required('Login Code / DSA Code is required')
    .notOneOf(['', ' ', null], 'Please select a valid DSA Code'),

  processingCenterName: yup
    .string()
    .required('Processing Center is required')
    .max(100, 'Processing Center must be less than 100 characters'),

  bankContactPersonName: yup
    .string()
    .required('Bank Contact Person is required')
    .max(50, 'Contact Person name must be less than 50 characters'),

  bankContactPersonMobile: yup
    .string()
    .required('Contact Person Mobile is required')
    .matches(/^[6-9][0-9]{9}$/, 'Enter a valid 10-digit mobile number'),

  submissionComments: yup
    .string()
    .required('Comments are required')
    .max(500, 'Comments must be less than 500 characters')
});

const RECOMMENDED_BANK_CODES = [
  'HDFC',
  'ICICI',
  'SBI',
  'AXIS',
  'KOTAK',
  'PNB',
  'BANK_OF_BARODA',
  'IDFC',
  'BANDHAN',
  'UNION_BANK'
];
function BankLogo({ bankName }) {
  const [logoError, setLogoError] = useState(false);

  return logoError ? (
    <Box
      width={120}
      height={50}
      display="flex"
      justifyContent="center"
      alignItems="center"
      sx={{
        border: '1px solid #ddd',
        borderRadius: '6px',
        background: '#fafafa'
      }}
    >
      <Icon icon="mdi:bank-outline" width={28} height={28} />
    </Box>
  ) : (
    <Box
      width={120}
      height={50}
      display="flex"
      justifyContent="center"
      alignItems="center"
      sx={{
        border: '1px solid #eee',
        borderRadius: '6px',
        background: '#fff'
      }}
    >
      <img
        alt={bankName}
        src={`../../static/bankLogo/${bankName?.toLowerCase()}_icon.png`}
        style={{
          maxWidth: '100%',
          maxHeight: '100%',
          objectFit: 'contain'
        }}
        onError={() => setLogoError(true)}
      />
    </Box>
  );
}

function ApplicationView({ parent, offlineResponse }) {
  const [camVersion, setCamVersion] = useState(' ');
  const [generatePopUp, setGeneratePopUp] = useState(false);
  const [downloadPopUp, setDownloadPopUp] = useState(false);
  const [sharePopUp, setSharePopUp] = useState(false);
  const [decisionEdit, setDecisionEdit] = useState(false);
  const [addPreference, setAddPreference] = useState(false);
  const [shareLetter, setShareLetter] = useState(false);
  const [selectWhat, setSelectWhat] = useState(' ');
  const [value, setValue] = useState(0);
  const [openLoader, setOpenLoader] = useState(false);
  const [isActive, setActive] = useState(false);
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [docPrevFlag, setDocPrevFlag] = useState({
    flag: false,
    srcPath: null,
    imgaltTag: null,
    contentType: null
  });
  const [approvButton, setApprovButton] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [masterTypeOptions, setMasterTypeOptions] = useState({
    leadSubmission: [],
    partnerLogin: [],
    dsaCodes: []
  });
  const [logoError, setLogoError] = useState(false);
  const [bankBranchId, setBankBranchId] = useState(null);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { leadesItem } = location?.state || {};
  const { LoginData } = useLoginSelector();
  const { BranchBankDrop } = useLeadSelector();
  const { BankDropdownData, BankDrop } = useGlobalSelector();
  const [leadProfile, setLeadProfile] = useState(null);
  const [bankSearch, setBankSearch] = useState('');
  const { UserProfileData, RecommendedBankData } = useLoginModuleSelector();

  // console.log('leadesItem2222', leadesItem?.[0]?.leadId);

  // console.log('BranchBankDrop2222', BranchBankDrop);

  // console.log('offlineResponse222', offlineResponse);

  // Recommendation list - derive from RecommendedBankData
  const recommendedBanks = RecommendedBankData?.banks || [];

  const RECOMMENDED_BANK_CODES = [
    'HDFC',
    'ICICI',
    'SBI',
    'AXIS',
    'KOTAK',
    'PNB',
    'BANK_OF_BARODA',
    'IDFC',
    'BANDHAN',
    'UNION_BANK'
  ];

  const BranchRecordByBank = useCallback(() => {
    if (!bankBranchId) return;

    const credential = {
      bankId: bankBranchId
    };
    dispatch(getBranchRecordByBank(credential));
  }, [LoginData, bankBranchId]);

  useEffect(() => {
    BranchRecordByBank();
  }, [BranchRecordByBank]);

  // Filter (skip kpis as requested)
  const filteredBanks = recommendedBanks.filter((bank) => {
    if (!bankSearch) return true;
    const term = bankSearch.toString().toLowerCase();
    return (
      String(bank.bankId).toLowerCase().includes(term) ||
      (bank.bankName || '').toLowerCase().includes(term) ||
      (bank.bankCode || '').toLowerCase().includes(term) ||
      String(bank.loanAmount || '')
        .toLowerCase()
        .includes(term)
    );
  });

  const getLeadProfile = useCallback(() => {
    if (!leadesItem?.[0]?.leadId) return;
    dispatch(getLoginUserProfile(leadesItem?.[0]?.leadId));
  }, [LoginData]);

  const geRecommendedBank = useCallback(() => {
    if (!leadesItem?.[0]?.leadId) return;
    dispatch(getRecoRecommendedBank(leadesItem?.[0]?.leadId));
  }, [LoginData]);

  useEffect(() => {
    getLeadProfile();
  }, [getLeadProfile]);

  useEffect(() => {
    geRecommendedBank();
  }, [geRecommendedBank]);

  // useEffect(() => {
  //   UserProfileData();
  // }, [UserProfileData]);

  const getBankDsaDetails = (bankId, bankList = BankDropdownData?.banks) => {
    setBankBranchId(bankId);
    const bank = bankList?.find((b) => b.bankId === bankId);
    const res = bank?.dsaCodes || [];

    const dsaOptions = transformToSelectOptions(res?.map((code) => ({ label: code, value: code })));

    setMasterTypeOptions((prev) => ({
      ...prev,
      dsaCodes: dsaOptions // update state with dropdown options
    }));
  };

  const {
    handleSubmit: handleReduxSubmit,
    control,
    reset,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(validationSchema) // call from add edit prospect
  });

  // show edit card
  const handleEditCard = (event, fields) => {
    reset();
    setIsEdit(true);
  };

  // close edit card
  const handleCloseCard = (event) => {
    setIsEdit(false);
  };

  // edit submit api
  const onSubmit = useCallback(
    async (data) => {
      const finalData = {
        ...data,
        applicationId: leadesItem?.[0]?.applicationId,
        processingBankBranch: data?.branchByBankId,
        leadId: leadesItem?.[0]?.leadId,
        companyId: LoginData?.companyId,
        userId: LoginData?.userId
      };

      try {
        const res = await dispatch(getLoginApproveProcess(finalData));
        if (res?.status === 'success') {
          handleCloseCard();
        }
      } catch (error) {
        console.error('Error submitting form:', error);
      }
    },
    [LoginData, leadesItem] // 🔹 depends on LoginData
  );

  // loan type & Bank Dropdown
  const getLoanTypeBankDropAPi = useCallback(() => {
    if (!LoginData) return;
    const data = {
      companyId: LoginData?.companyId,
      userId: LoginData?.userId,
      isWithCode: true
    };
    dispatch(getBankDropdownData(data));
  }, []);

  // master type data
  const MasterTypeApi = async () => {
    const subType = 'LEAD_SUBMISSION_TYPE';
    const partnerType = 'PARTNER_APPLICATION_LOGIN_TYPE';
    const leadSubmissionRes = await dispatch(getMasterListType(subType));
    const partnerLoginRes = await dispatch(getMasterListType(partnerType));

    const leadSubmissionOptions = transformToSelectOptions(
      leadSubmissionRes?.data?.masterTypes || [],
      'typeName',
      'typeId'
    );

    const partnerLoginOptions = transformToSelectOptions(
      partnerLoginRes?.data?.masterTypes || [],
      'typeName',
      'typeId'
    );

    setMasterTypeOptions((prev) => ({
      ...prev,
      leadSubmission: leadSubmissionOptions,
      partnerLogin: partnerLoginOptions
    }));
  };

  useEffect(() => {
    if (parent === 'login') {
      MasterTypeApi(); // master list
      getLoanTypeBankDropAPi(); // Bank Dropdown
    }
  }, [parent, value]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setOpenLoader(true);
    setTimeout(() => {
      setOpenLoader(false);
    }, 500);
  };

  const toggleClass = (box) => {
    setActive(box);
  };

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setPageNumber(1);
  }

  const docPrevHandler = (type, srcData) => {
    if (type === 'open') {
      const responseData = JSON.parse(srcData);
      setDocPrevFlag({
        flag: true,
        srcPath: responseData.src,
        imgaltTag: responseData.alt,
        contentType: responseData.contentType
      });
    } else {
      setDocPrevFlag({ flag: false, srcPath: null, imgaltTag: null, contentType: null });
    }
  };

  // Helper function to generate document payloads
  const generateDocumentPayloads = (reviewCards) =>
    reviewCards?.flatMap((reviewCardsItem) =>
      reviewCardsItem.selectedJourneyReviewCards.flatMap((selectedJourneyReviewCardsItem) =>
        selectedJourneyReviewCardsItem.reviewCardFields.flatMap((reviewCardFieldsItem) => {
          const docMap = reviewCardFieldsItem?.cardDetail?.storedField?.documentMap;
          if (!docMap) return [];

          return Object.keys(docMap).map((documentMapItem) => {
            const path = docMap[documentMapItem]?.path ?? null;
            const fieldHeading =
              reviewCardFieldsItem?.reviewCardFieldHeading ??
              reviewCardFieldsItem?.cardDetail?.cardFieldMapping?.journeyCardFieldsMaster
                ?.fieldName;

            return {
              applicationDetailsId: path ? path.split('/')[path.split('/').length - 4] : null,
              cardDetailId: reviewCardFieldsItem.cardDetail.cardDetailId,
              faceValue: path ? path.split('/')[path.split('/').length - 1] : null,
              journeyCardId: reviewCardFieldsItem.cardDetail.journeyCardId,
              contentType: docMap[documentMapItem]?.contentType ?? null,
              documentName: documentMapItem === 'frontFace' ? fieldHeading : `${fieldHeading} Back`,
              path,
              status: null,
              verifiedStatus: null,
              type:
                selectedJourneyReviewCardsItem?.selectedJourneyCard?.cardPurpose?.cardPurposeName ??
                null
            };
          });
        })
      )
    );

  const renderFieldItem = (label, value) => (
    <Grid item xs={4} key={label}>
      <Box className="displayFlex">
        {/* <img
          style={{
            width: '45px',
            marginRight: '15px',
            borderRadius: '5px'
          }}
          src={profileImg} // placeholder icon (same style as earlier)
          alt=""
        /> */}
        <Box>
          <Typography variant="body2" className="labelText">
            {label}
          </Typography>
          <Typography variant="subtitle2" className="labelValue">
            {value ?? 'Not Available'}
          </Typography>
        </Box>
      </Box>
    </Grid>
  );

  return (
    <Box>
      <Loader openLoader={openLoader} />
      <Tabs
        value={value}
        onChange={handleChange}
        className="tabOuter"
        aria-label="basic tabs example"
        classes={{ indicator: 'tabIndicator' }}
      >
        <Tab
          label="User Profile"
          {...a11yProps(0)}
          classes={{ selected: 'tabSelected', root: 'tabDefault' }}
        />
        <Tab
          label="Recommendation List"
          {...a11yProps(1)}
          classes={{ selected: 'tabSelected', root: 'tabDefault' }}
        />

        {/* <Tab
          label="CAM"
          {...a11yProps(1)}
          classes={{ selected: 'tabSelected', root: 'tabDefault' }}
          disabled="true"
        />
        <Tab
          label="Recommendation"
          {...a11yProps(2)}
          classes={{ selected: 'tabSelected', root: 'tabDefault' }}
          disabled={parent !== 'login' ? true : false}
        /> */}
      </Tabs>
      {/* tab panel first start */}
      <TabPanel value={value} index={0}>
        <Box className="topToolbar">
          {/* <Button
            className={
              approvButton === 'U-Login' ? 'mainBtn otherBtn disabledDocument' : 'mainBtn otherBtn'
            }
            // onClick={(e) => setSendProcessing(true)}
            onClick={(e) => handleEditCard()}
          >
            Approve for Processing
          </Button> */}
          {parent === 'login' && (
            <Tooltip title="Approve for Processing" placement="top" arrow>
              <IconButton
                className="squareIconButton"
                // onClick={(e) => setSendProcessing(true)}
                onClick={(e) => handleEditCard()}
                disabled={leadesItem?.[0]?.logInStatusName === 'New' ? false : true}
              >
                <MdCheckBox size={18} />
              </IconButton>
            </Tooltip>
          )}
          &nbsp;
          {/* <Tooltip title="Print & Download" placement="top" arrow>
            <IconButton
              className="squareIconButton"
              onClick={(e) => {
                const allDocument = generateDocumentPayloads(offlineResponse.reviewCards);
                if (allDocument.length > 0) {
                  localStorage.setItem(
                    'allDocumentList',
                    JSON.stringify({ documentList: allDocument })
                  );
                }
                navigate(`/leads/process/print-download`);
              }}
              disabled
            >
              <RiPrinterCloudFill size={18} />
            </IconButton>
          </Tooltip> */}
        </Box>
        <Box>
          {!UserProfileData ? (
            <Typography variant="body2">No profile data available.</Typography>
          ) : (
            <>
              {/* Loan Profile */}
              <Typography variant="body1" className="headingLineUp headingLineUpOut">
                Loan Profile
              </Typography>
              <Box className="viewLeadCard cardTopMinusMargin" mb={3}>
                <Grid container spacing={3}>
                  {renderFieldItem(
                    'Loan Amount Requested',
                    UserProfileData?.loanProfile?.loanAmountRequested
                  )}
                  {renderFieldItem('Loan Type', UserProfileData?.loanProfile?.loanType)}
                  {renderFieldItem('Tenure', UserProfileData?.loanProfile?.tenure)}
                  {renderFieldItem('Monthly Income', UserProfileData?.loanProfile?.monthlyIncome)}
                  {renderFieldItem('Annual Income', UserProfileData?.loanProfile?.annualIncome)}
                  {renderFieldItem(
                    'Monthly Obligation',
                    UserProfileData?.loanProfile?.monthlyObligation
                  )}
                  {renderFieldItem('FOIR', UserProfileData?.loanProfile?.foir)}
                  {renderFieldItem('Employment Type', UserProfileData?.loanProfile?.employmentType)}
                  {renderFieldItem('Residence Type', UserProfileData?.loanProfile?.residenceType)}
                  {renderFieldItem('Property Type', UserProfileData?.loanProfile?.propertyType)}
                  {renderFieldItem('Market Value', UserProfileData?.loanProfile?.marketValue)}
                </Grid>
              </Box>

              {/* Applicant Profile */}
              <Typography variant="body1" className="headingLineUp headingLineUpOut">
                Applicant Profile
              </Typography>
              <Box className="viewLeadCard cardTopMinusMargin" mb={3}>
                <Grid container spacing={3}>
                  {renderFieldItem('Full Name', UserProfileData?.applicantProfile?.fullName)}
                  {renderFieldItem('First Name', UserProfileData?.applicantProfile?.firstName)}
                  {renderFieldItem('Middle Name', UserProfileData?.applicantProfile?.middleName)}
                  {renderFieldItem('Last Name', UserProfileData?.applicantProfile?.lastName)}
                  {renderFieldItem('Mobile', UserProfileData?.applicantProfile?.mobile)}
                  {renderFieldItem('Email', UserProfileData?.applicantProfile?.email)}
                  {renderFieldItem('Gender', UserProfileData?.applicantProfile?.gender)}
                  {renderFieldItem('Date of Birth', UserProfileData?.applicantProfile?.dob)}
                  {renderFieldItem('Age', UserProfileData?.applicantProfile?.age)}
                  {renderFieldItem(
                    'Marital Status',
                    UserProfileData?.applicantProfile?.marriageType
                  )}
                  {renderFieldItem(
                    'Is Co-Applicant',
                    UserProfileData?.applicantProfile?.isCoApplicant === null
                      ? null
                      : UserProfileData?.applicantProfile?.isCoApplicant
                      ? 'Yes'
                      : 'No'
                  )}
                </Grid>
              </Box>

              {/* Address */}
              <Typography variant="body1" className="headingLineUp headingLineUpOut">
                Address Details
              </Typography>
              <Box className="viewLeadCard cardTopMinusMargin" mb={3}>
                <Grid container spacing={3}>
                  {renderFieldItem(
                    'Residence Address 1',
                    UserProfileData?.address?.residenceAddress1
                  )}
                  {renderFieldItem(
                    'Residence Address 2',
                    UserProfileData?.address?.residenceAddress2
                  )}
                  {renderFieldItem(
                    'Current Address 1',
                    UserProfileData?.address?.curResidenceAddress1
                  )}
                  {renderFieldItem(
                    'Current Address 2',
                    UserProfileData?.address?.curResidenceAddress2
                  )}
                  {renderFieldItem('Pincode', UserProfileData?.address?.pincode)}
                  {renderFieldItem('Current Pincode', UserProfileData?.address?.curPincode)}
                  {renderFieldItem('District Id', UserProfileData?.address?.districtId)}
                  {renderFieldItem('Province Id', UserProfileData?.address?.provinceId)}
                  {renderFieldItem('Country Id', UserProfileData?.address?.countryId)}
                  {renderFieldItem('Residence Since', UserProfileData?.address?.residenceSince)}
                </Grid>
              </Box>

              {/* KYC */}
              <Typography variant="body1" className="headingLineUp headingLineUpOut">
                KYC Details
              </Typography>
              <Box className="viewLeadCard cardTopMinusMargin" mb={3}>
                <Grid container spacing={3}>
                  {renderFieldItem('PAN', UserProfileData?.kyc?.panId)}
                  {renderFieldItem('PAN Verified', UserProfileData?.kyc?.isPanVerify)}
                  {renderFieldItem('Aadhar', UserProfileData?.kyc?.aadharId)}
                  {renderFieldItem('Aadhar Verified', UserProfileData?.kyc?.isAadharVerify)}
                  {renderFieldItem('GST', UserProfileData?.kyc?.gst)}
                  {renderFieldItem('GST Verified', UserProfileData?.kyc?.isGstVerify)}
                  {renderFieldItem('ITR Username', UserProfileData?.kyc?.itrUsername)}
                  {renderFieldItem('ITR Verified', UserProfileData?.kyc?.isItrVerify)}
                  {renderFieldItem('Business PAN', UserProfileData?.kyc?.businessPan)}
                  {renderFieldItem(
                    'Business PAN Verified',
                    UserProfileData?.kyc?.isBusinessPanVerify
                  )}
                  {renderFieldItem('CIN', UserProfileData?.kyc?.cin)}
                  {renderFieldItem('CIN Verified', UserProfileData?.kyc?.isCinVerify)}
                  {renderFieldItem('DIN', UserProfileData?.kyc?.din)}
                  {renderFieldItem('DIN Verified', UserProfileData?.kyc?.isDinVerify)}
                  {renderFieldItem('Email Verified', UserProfileData?.kyc?.isEmailVerify)}
                  {renderFieldItem(
                    'Bank Statement Uploaded',
                    UserProfileData?.kyc?.isBankStatement
                  )}
                  {renderFieldItem('Bureau Verified', UserProfileData?.kyc?.isBureauVerify)}
                  {renderFieldItem(
                    'Auto Bureau Verified',
                    UserProfileData?.kyc?.isBureauAutoVerify
                  )}
                  {renderFieldItem('CIBIL Score', UserProfileData?.kyc?.cibilScore)}
                  {renderFieldItem('Bureau Company', UserProfileData?.kyc?.bureauCompany)}
                </Grid>
              </Box>

              {/* Workflow */}
              <Typography variant="body1" className="headingLineUp headingLineUpOut">
                Workflow
              </Typography>
              <Box className="viewLeadCard cardTopMinusMargin" mb={3}>
                <Grid container spacing={3}>
                  {renderFieldItem('Lead Id', UserProfileData?.leadId)}
                  {renderFieldItem('Prospect Id', UserProfileData?.prospectId)}
                  {renderFieldItem('Status', UserProfileData?.status)}
                  {renderFieldItem('Current Stage', UserProfileData?.workflow?.currentStageName)}
                  {renderFieldItem('Current Stage Id', UserProfileData?.workflow?.currentStageId)}
                  {renderFieldItem('Current Status', UserProfileData?.workflow?.currentStatus)}
                  {renderFieldItem('Assigned To', UserProfileData?.workflow?.assignedTo)}
                  {renderFieldItem('Assigned To Name', UserProfileData?.workflow?.assignedToName)}
                  {renderFieldItem('Assigned On', UserProfileData?.workflow?.assignedOn)}
                  {renderFieldItem('Last Updated On', UserProfileData?.workflow?.lastUpdatedOn)}
                </Grid>
              </Box>
            </>
          )}
        </Box>
      </TabPanel>
      {/* tab panel thrid start */}
      <TabPanel value={value} index={1}>
        <Box
          className="viewLeadCard cardTopMinusMargin recommendationCard"
          style={{ marginTop: '20px' }}
        >
          <Box className="recommendationHeader">
            <Box>
              <Typography variant="subtitle2" className="headingLineUp">
                Recommended Bank List
              </Typography>
              <Typography variant="body2" className="subText">
                Banks shortlisted as per your internal recommendation logic.
              </Typography>
            </Box>

            <Box style={{ display: 'flex', justifyContent: 'end', marginBottom: '10px' }}>
              <SearchStyle
                value={bankSearch}
                onChange={(e) => setBankSearch(e.target.value)}
                placeholder="Search bank list"
                classes={{ root: 'searchHolder', input: 'searchInput' }}
                startAdornment={
                  <InputAdornment position="start">
                    <Box component={Icon} icon={searchFill} sx={{ color: 'text.disabled' }} />
                  </InputAdornment>
                }
              />
            </Box>
          </Box>

          <Divider />

          <Scrollbar style={{ maxHeight: 420 }}>
            <TableContainer>
              <Table size="small" stickyHeader>
                <TableHead>
                  <StyledTableRow>
                    {/* <StyledTableCell width={80}>Bank ID</StyledTableCell> */}
                    <StyledTableCell>Bank Name</StyledTableCell>
                    <StyledTableCell align="right">Loan Amount</StyledTableCell>
                    <StyledTableCell align="right">Interest Rate</StyledTableCell>
                    <StyledTableCell align="right">EMI</StyledTableCell>
                    <StyledTableCell align="right">Tenure</StyledTableCell>
                    <StyledTableCell align="right">processing Fees</StyledTableCell>
                    {/* <StyledTableCell align="center" width={140}>
                      Recommendation
                    </StyledTableCell> */}
                  </StyledTableRow>
                </TableHead>

                <TableBody>
                  {/* {console.log('filteredBanks222', filteredBanks)} */}
                  {filteredBanks.map((bank) => (
                    <StyledTableRow key={bank.bankId} hover>
                      {/* <StyledTableCell>{bank.bankId}</StyledTableCell> */}
                      <StyledTableCell width={100}>
                        <Box display="flex" alignItems="center">
                          <BankLogo bankName={bank.bankName} />

                          <Typography ml={1} variant="subtitle2" sx={{ fontSize: '10px' }}>
                            {bank.bankName}
                          </Typography>
                        </Box>
                      </StyledTableCell>
                      {/* <StyledTableCell>
                        {bank.bankName || bank.bankCode || 'Unknown'}
                      </StyledTableCell> */}
                      <StyledTableCell align="right">{bank.loanAmount ?? 'NA'}</StyledTableCell>
                      <StyledTableCell align="right">{bank.interestRate ?? 'NA'}</StyledTableCell>
                      <StyledTableCell align="right">{bank.emi ?? 'NA'}</StyledTableCell>
                      <StyledTableCell align="right">{bank.tenure ?? 'NA'}</StyledTableCell>
                      <StyledTableCell style={{ textAlign: 'center' }}>
                        {bank.processingFees ?? 'NA'}
                      </StyledTableCell>
                      {/* <StyledTableCell align="center">
                          {isRecommended ? (
                            <span className="recommendedChip">Recommended</span>
                          ) : (
                            <span className="otherChip">Optional</span>
                          )}
                        </StyledTableCell> */}
                    </StyledTableRow>
                  ))}

                  {filteredBanks.length === 0 && (
                    <StyledTableRow>
                      <StyledTableCell colSpan={6} align="center">
                        <Typography variant="body2" color="text.secondary">
                          No banks found for “{bankSearch}”.
                        </Typography>
                      </StyledTableCell>
                    </StyledTableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Scrollbar>

          {/* small footer showing total count if available from API */}
          <Box mt={2} display="flex" justifyContent="space-between">
            <Typography variant="body2">
              Total Banks: {RecommendedBankData?.totalBanks ?? recommendedBanks.length}
            </Typography>
            <Typography variant="body2">Displayed: {filteredBanks.length}</Typography>
          </Box>
        </Box>
      </TabPanel>

      <CustomDialog
        showCloseIcon
        open={isEdit}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
            handleCloseCard();
          }
        }}
        title="Submission"
        content={
          <Box mb={3}>
            <form id="EditLoanRequirementForm" onSubmit={handleReduxSubmit(onSubmit)}>
              <Grid container spacing={3} mb={3}>
                <Grid item xs={6}>
                  <CustomSelect
                    name="submittedToBankId"
                    label="Bank Name"
                    control={control}
                    errors={errors}
                    options={BankDrop || []}
                    isRequired
                    onChange={(event, val, option, reason, details) => {
                      getBankDsaDetails(val);
                      // handleBankChange(val);
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <CustomSelect
                    name="branchByBankId"
                    label="Branch"
                    control={control}
                    errors={errors}
                    options={BranchBankDrop || []}
                    isRequired
                    // onChange={(event, val, option, reason, details) => {
                    //   getBankDsaDetails(val);
                    //   // handleBankChange(val);
                    // }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <CustomSelect
                    name="submissionModeTypeId"
                    label="Mode of Submission"
                    control={control}
                    errors={errors}
                    options={masterTypeOptions?.leadSubmission || []}
                    isRequired
                  />
                </Grid>
                <Grid item xs={6}>
                  <CustomSelect
                    name="loginTypeId"
                    label="Login Type"
                    control={control}
                    errors={errors}
                    options={masterTypeOptions?.partnerLogin || []}
                    isRequired
                  />
                </Grid>
                <Grid item xs={6}>
                  <CustomSelect
                    name="dsaLoginCode"
                    label="Login Code/DSA Code"
                    control={control}
                    errors={errors}
                    options={masterTypeOptions?.dsaCodes || []}
                    isRequired
                  />
                </Grid>
                <Grid item xs={6}>
                  <CustomInput
                    name="processingCenterName"
                    label="Processing Center"
                    control={control}
                    errors={errors}
                    isRequired
                  />{' '}
                </Grid>
                <Grid item xs={6}>
                  <CustomInput
                    name="bankContactPersonName"
                    label="Bank Contact Person"
                    control={control}
                    errors={errors}
                    isRequired
                  />
                </Grid>
                <Grid item xs={6}>
                  <CustomInput
                    name="bankContactPersonMobile"
                    label="Contact Person Mobile"
                    control={control}
                    errors={errors}
                    isRequired
                  />
                </Grid>

                <Grid item xs={12}>
                  <CustomInput
                    name="submissionComments"
                    label="Comments"
                    type="textarea"
                    rows={2}
                    control={control}
                    errors={errors}
                    multiline
                    isRequired
                  />
                </Grid>
              </Grid>{' '}
            </form>{' '}
          </Box>
        }
        actions={
          <Box display="flex" justifyContent="flex-end" gap={2}>
            <Button
              variant="contained"
              sx={{
                backgroundColor: '#f5f5f5', // light grey
                color: '#000', // black text
                '&:hover': {
                  backgroundColor: '#e0e0e0' // darker grey on hover
                }
              }}
              onClick={handleCloseCard}
            >
              Cancel
            </Button>

            <Button
              type="submit"
              form="EditLoanRequirementForm"
              variant="contained"
              className="mainBtn"
              color="primary"
            >
              Save{' '}
            </Button>
          </Box>
        }
      />
      <Dialog
        className="PopupBox"
        open={docPrevFlag.flag}
        onClose={() => docPrevHandler('close', '')}
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle className="popupHeading">
          <Typography variant="h6" className="popupTitle">
            {docPrevFlag.contentType === 'content'
              ? 'Document Size Error '
              : docPrevFlag.contentType === 'validation'
              ? 'Required Fields'
              : 'Document Preview'}
          </Typography>
          <IconButton onClick={() => docPrevHandler('close', '')} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers className="PopupContent">
          <DialogContentText>
            {docPrevFlag.contentType === 'content' || docPrevFlag.contentType === 'validation' ? (
              docPrevFlag.imgaltTag
            ) : docPrevFlag.contentType === 'application/pdf' ? (
              <Document
                file={docPrevFlag.srcPath}
                onLoadSuccess={(numPages) => onDocumentLoadSuccess(numPages)}
              >
                <Pages pageNumber={pageNumber} />
              </Document>
            ) : (
              <img src={docPrevFlag.srcPath} alt={docPrevFlag.imgaltTag} />
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button className="mainBtn" onClick={() => docPrevHandler('close', '')}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
export default ApplicationView;

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ paddingTop: '1rem' }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  };
}
